import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../../../../../authentication/AuthContext';
import axios from 'axios';
import UserContext from '../../../../../user/UserContext';
import AdvertisingCarousel from './AdvertisingCarousel';
import OrderContext from '../../../OrderContext';

export default function SubmissionAdvertising() {
    const cas = useContext(AuthContext);
    const { userDetails } = useContext(UserContext);
    const { orderHeader } = useContext(OrderContext);
    const { orderId } = useContext(OrderContext);
    const [imageUrl, setImageUrl] = useState();
    const [productCodes, setProductCodes] = useState([]);
    const [upsoldFrom, setUpsoldFrom] = useState('');
    const [showCarousel, setShowCarousel] = useState(false);

    useEffect(() => {
        axios
            .post(
                window.CONFIG['ws.activoc-web-order-api.advertising'],
                {
                    location: 'Pre_Submit',
                    supplierCode: orderHeader.supplierCode,
                    franchiseCode: userDetails.currentFranchise.code,
                    orderId: orderId
                },
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                setImageUrl(response.data.imageUrl);
                if (response.data.productCodes != null) {
                    setProductCodes(response.data.productCodes);
                }
                setUpsoldFrom(response.data.upsoldFrom);
            });
    }, [cas, orderHeader.supplierCode, userDetails.currentFranchise.code, orderId]);

    return (
        <div className={'submission-advertising'}>
            {productCodes.length > 0 &&
                (showCarousel || !imageUrl ? (
                    <AdvertisingCarousel productCodes={productCodes} upsoldFrom={upsoldFrom} />
                ) : (
                    <button className={'img-button'} onClick={() => setShowCarousel(true)}>
                        <img src={imageUrl} alt={'Current period advertising'} />
                    </button>
                ))}
        </div>
    );
}
